import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export const useIsInsightsLeadersMyAnalyticsEnabled: UseUIFeatureCheck = () => {
  const vivaInsightsLeadersMyAnalyticsExperiment = useExperimentTreatmentWithoutReporting(
    Experiment.VivaInsightsLeadersMyAnalytics
  );
  const vivaEngagePremiumExperiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium);

  return vivaInsightsLeadersMyAnalyticsExperiment === true || vivaEngagePremiumExperiment === true;
};

export const useIsUserInsightsEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.UserInsights) === true;
